module.exports = __webpack_public_path__ + "img/img4.0c1ceb8c.png";